import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { AlertStatisticsResponse } from "app/core/models/alert-statistics-response";
import { SimpleStatisticsResponse } from "app/core/models/simple-statistics-response";
import { ComplexStatisticsResponse } from "app/core/models/complex-statistics-response";

@Injectable()
export class StatisticsService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getAlertStatistics( id: string, from_date: string, end_date: string): Observable<AlertStatisticsResponse> {

    
    let params = new HttpParams()
    .set('from_date', from_date.toString())
    .set('end_date', end_date.toString());

    return this._httpClient.get(`${environment.apiUrl}/statistics/alerts/${id}`, {
      params: params
      }).pipe(
          
          map(res =>  <AlertStatisticsResponse>res)
      );
  }  

  public getSyntheticProfileStatistics( id: string, from_date: string, end_date: string, forecast: boolean = false): Observable<SimpleStatisticsResponse> {

    
    let params = new HttpParams()
    .set('from_date', from_date.toString())
    .set('end_date', end_date.toString());

    if(forecast) {
      params = params.set('forecast', forecast);
    }

    return this._httpClient.get(`${environment.apiUrl}/statistics/synthetic_profiles/${id}`, {
      params: params
      }).pipe(
          
          map(res =>  <SimpleStatisticsResponse>res)
      );
  }    

  public getProfileStatistics( id: string, from_date: string, end_date: string, forecast: boolean = false): Observable<SimpleStatisticsResponse> {

    
    let params = new HttpParams()
    .set('from_date', from_date.toString())
    .set('end_date', end_date.toString());

    if(forecast) {
      params = params.set('forecast', forecast);
    }

    return this._httpClient.get(`${environment.apiUrl}/statistics/profiles/${id}`, {
      params: params
      }).pipe(
          
          map(res =>  <SimpleStatisticsResponse>res)
      );
  }     

  public getUserStatistics( id: string): Observable<AlertStatisticsResponse> {

    
    let params = new HttpParams();
    
    return this._httpClient.get(`${environment.apiUrl}/statistics/users/${id}/activity`, {
      params: params
      }).pipe(
          
          map(res =>  <AlertStatisticsResponse>res)
      );
  }    

  public getQueueStatistics( id: string, from_date: string, end_date: string, forecast: boolean = false): Observable<ComplexStatisticsResponse> {
    
    let params = new HttpParams()
    .set('from_date', from_date.toString())
    .set('end_date', end_date.toString());

    if(forecast) {
      params = params.set('forecast', forecast);
    }

    return this._httpClient.get(`${environment.apiUrl}/statistics/queues/${id}`, {
      params: params
      }).pipe(
          
          map(res =>  <ComplexStatisticsResponse>res)
      );
  }       
}
